import { Card } from "react-bootstrap";
import Loading from "../loading/Loading";
import { Link } from "react-router-dom";

function ComunidadMembresíaTabla({ membresia, total, title = 'Resumen de Membresía', groupByLabel = 'Tipo de Miembro', link = false}) {
  const data = membresia;

  if (!data) {
    return <Card>
      <Card.Header>{title}</Card.Header>
      <Card.Body>
        <Loading text='Cargando...'/>
      </Card.Body>
    </Card>
  }
  return <Card>
    <Card.Header>{title}</Card.Header>
    <Card.Body>
      <table>
        <thead><tr>
          <td>{groupByLabel}</td><td>Miembros (Pagados)</td>
        </tr></thead>
        <tbody>
          {
          data.map((d, idx) => {
            let label = d.label;
            if (link && d.link) {
              label = <Link to={d.link}>{d.label}</Link>;
            }

            return <tr key={`mem-row-${idx}`}>
              <td key={`mem-label-${idx}`}>{label}</td>
              <td key={`mem-data-${idx}`}>{d.members_count}({d.paid_members_count})</td>
            </tr>;
          })
          }
          {
            <tr className="total">
              <td>Total</td>
              <td>{total.count}({total.paid})</td>
            </tr>
          }
        </tbody>
      </table>
    </Card.Body>
  </Card>
}

export default ComunidadMembresíaTabla;
